import { Card, Typography } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { T, TPlainTextKey } from '../../../../Translations';
import Title from '../../Shared/Title';
import { KeyMetricsPayload, KeyMetricsTitle } from './Decoder';
import EmptyDataCheck from './EmptyDataCheck';

interface Props {
  keyMetrics: KeyMetricsPayload;
  title: KeyMetricsTitle;
  rangeText: TPlainTextKey;
}

function Content({ keyMetrics, title, rangeText }: Props) {
  return (
    <Card className="grow min-w-[32%] max-w-[48%] px-3.5 py-6 sm:max-w-full" radius="lg">
      <Title label={title} />
      <div className="flex my-4">
        <EmptyDataCheck title={title} keyMetrics={keyMetrics} />
        <div className="flex items-center">
          <Typography color="dark" variant="caption">
            <T kind={rangeText} />
          </Typography>
        </div>
      </div>
    </Card>
  );
}

export default observer(Content);
